import common from "./common.json";
import navbar from "./navbar/navbar.json";
import personalManagement from "./cms/personal-management/personal-management.json";
import studentManagement from "./cms/manage-students/manage-students.json";
import onlineLeaveSubmission from "./cms/online-leave-submission/online-leave-submission.json";
import manageOnlineLeaveSubmission from "./cms/manage-online-leave-submission/manage-online-leave-submission.json";
import manageJobTitles from "./cms/manage-job-titles/manage-job-titles.json";
import organizationChartManagement from "./cms/organization-chart-management/organization-chart-management.json";
import courseManagement from "./cms/course-management/course_management.json";
import courseOfStudy from "./cms/course-of-study/course-of-study.json";
import eMeeting from "./cms/e-meeting/e-meeting.json";
import complaints from "./cms/complaints/complaints.json";
import homepage from "./home/homepage.json";
import listApplicants from "./admission/list-applicants.json";
import interviewStudent from "./admission/interview-student.json";
import manageExams from "./admission/manage-exams.json";
import levelFacultyManagement from "./admission/level-faculty-management.json";
import manageAcademicYear from "./admission/manage-academic-year.json";
import managePDPA from "./admission/manage-PDPA.json";
import setupCourseOpening from "./admission/setup-course-opening.json";
import setTuitionFees from "./admission/set-tuition-fees.json";
import managePayment from "./admission/manage-payment.json";
import termPayment from "./admission/term-payment.json";
import studentRegistration from "./admission/student-registration.json";
import periodExamination from "./admission/period-examination.json";

export const LocaleTh = {
  ...common,
  ...navbar,
  ...personalManagement,
  ...studentManagement,
  ...onlineLeaveSubmission,
  ...manageOnlineLeaveSubmission,
  ...manageJobTitles,
  ...organizationChartManagement,
  ...courseManagement,
  ...courseOfStudy,
  ...eMeeting,
  ...complaints,
  ...homepage,
  ...listApplicants,
  ...interviewStudent,
  ...manageExams,
  ...levelFacultyManagement,
  ...manageAcademicYear,
  ...managePDPA,
  ...setupCourseOpening,
  ...setTuitionFees,
  ...managePayment,
  ...termPayment,
  ...studentRegistration,
  ...periodExamination
};
